"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addHashParam = exports.startParamsWithHash = exports.getHash = void 0;
const queryString = require('query-string');
const getHash = () => {
    const parsed = queryString.parse(window.location.search);
    return parsed.hash;
};
exports.getHash = getHash;
const startParamsWithHash = () => {
    const parsed = queryString.parse(window.location.search);
    return `?hash=${parsed.hash}`;
};
exports.startParamsWithHash = startParamsWithHash;
const addHashParam = () => {
    const parsed = queryString.parse(window.location.search);
    return `&hash=${parsed.hash}`;
};
exports.addHashParam = addHashParam;
